import React from 'react';

export const ValidationModeContext = React.createContext('save'); // default: 'save'
